import React, { useEffect, useState, Component } from 'react';
import { Toast, ToastType } from './Toast';
export interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}
interface ToastContainerProps {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
}
// Create a singleton instance for the toast container
let toastContainerInstance: ToastContainer | null = null;
export class ToastContainer extends Component<ToastContainerProps, {
  toasts: ToastMessage[];
}> {
  constructor(props: ToastContainerProps) {
    super(props);
    this.state = {
      toasts: []
    };
    // Set the singleton instance
    toastContainerInstance = this;
  }
  // Method to add a toast
  addToast = (message: string, type: ToastType = 'info', duration = 5000) => {
    const id = Date.now().toString();
    const newToast: ToastMessage = {
      id,
      message,
      type,
      duration
    };
    this.setState(prevState => ({
      toasts: [...prevState.toasts, newToast]
    }));
    return id;
  };
  // Method to remove a toast
  removeToast = (id: string) => {
    this.setState(prevState => ({
      toasts: prevState.toasts.filter(toast => toast.id !== id)
    }));
  };
  // Get position classes
  getPositionClasses() {
    const {
      position = 'top-right'
    } = this.props;
    switch (position) {
      case 'top-left':
        return 'top-4 left-4';
      case 'top-center':
        return 'top-4 left-1/2 transform -translate-x-1/2';
      case 'bottom-right':
        return 'bottom-4 right-4';
      case 'bottom-left':
        return 'bottom-4 left-4';
      case 'bottom-center':
        return 'bottom-4 left-1/2 transform -translate-x-1/2';
      case 'top-right':
      default:
        return 'top-4 right-4';
    }
  }
  render() {
    const {
      toasts
    } = this.state;
    const positionClasses = this.getPositionClasses();
    return <div className={`fixed z-50 ${positionClasses} flex flex-col space-y-2 max-w-md w-full`} data-id="element-12708">
        {toasts.map(toast => <Toast key={toast.id} message={toast.message} type={toast.type} duration={toast.duration} onClose={() => this.removeToast(toast.id)} data-id="element-12709" />)}
      </div>;
  }
}
// Helper functions to show toasts from anywhere in the app
export const showToast = {
  success: (message: string, duration = 5000) => {
    return toastContainerInstance?.addToast(message, 'success', duration);
  },
  error: (message: string, duration = 5000) => {
    return toastContainerInstance?.addToast(message, 'error', duration);
  },
  info: (message: string, duration = 5000) => {
    return toastContainerInstance?.addToast(message, 'info', duration);
  },
  warning: (message: string, duration = 5000) => {
    return toastContainerInstance?.addToast(message, 'warning', duration);
  }
};